export const themeColors = [
  {
    name: 'blue-theme',
    color: '#1A97F5',
  },
  {
    name: 'green-theme',
    color: '#03C9D7',
  },
  {
    name: 'purple-theme',
    color: '#7352FF',
  },
  {
    name: 'red-theme',
    color: '#FF5C8E',
  },
  {
    name: 'indigo-theme',
    color: '#1E4DB7',
  },
  {
    name: 'orange-theme',
    color: '#FB9678',
  },
  {
    name: 'filo-green-theme',
    color: '#a5bf45', // verde claro (logo)
  },
  {
    name: 'filo-green-dark-theme',
    color: '#60731e', // verde escuro
  },
  {
    name: 'filo-green-darker-theme',
    color: '#465944', // verde de fundo
  },
];
